var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material';
import { StandardLayout } from '../StandardLayout';
export var FullBackgroundLayout = function (_a) {
    var children = _a.children, image = _a.image, footer = _a.footer, backgroundStyles = _a.backgroundStyles;
    return (_jsx(StandardLayout, { content: _jsx(Background, __assign({ image: image, className: "relative min-h-widget ", backgroundStyles: backgroundStyles }, { children: children })), footer: footer }));
};
var Background = styled('div', {
    shouldForwardProp: function (prop) { return prop !== 'image' && prop !== 'backgroundStyles'; },
})(function (_a) {
    var image = _a.image, backgroundStyles = _a.backgroundStyles;
    return (__assign({ position: 'absolute', top: 0, width: '100vw', backgroundImage: "url(".concat(image, ")"), backgroundSize: 'cover', backgroundPosition: '50% 50%', backgroundRepeat: 'no-repeat' }, backgroundStyles));
});
